// 005: every string of the shopping screens (spec Clarifications, US1, US2, FR-013, FR-027, FR-028).
import type { AppError } from "@/api/client";

export const SHOP_COPY = {
  categoriesTitle: "Shop",
  categoriesLead: "Pick a category for the child you're shopping for.",
  comingSoon: "Coming soon",
  booksNote:
    "Books shown are based on the selected student's class and section.",
  orderingFor: "Ordering for",
  addStudent: "Add student",
  allSubjects: "All subjects",
  languages: "Languages",
  workbooks: "Workbooks",
  booklistChip: (cls: string) => `${cls} booklist`,
  add: "Add",
  mandatory: "Mandatory",
  optional: "Optional",
  notAvailable: "Not available",
  increase: "Increase",
  decrease: "Decrease",
  quantityOf: (name: string, qty: number) => `Quantity of ${name}, ${qty}`,
  fullSet: (count: number, total: string) =>
    `Add full set (${count} ${count === 1 ? "item" : "items"}) · ${total}`,
  fullSetShort: (count: number) =>
    `Add full set (${count} ${count === 1 ? "item" : "items"})`,
  fullSetAdded: (count: number, name: string) =>
    `${count} ${count === 1 ? "item" : "items"} added for ${name}`,
  alreadyInCart: "Already in your cart",
  booklistTitle: (name: string, cls: string) => `Booklist for ${name} · ${cls}`,
  recommendedBy: (school: string) => `Recommended by ${school}`,
  noBooklist: (cls: string) =>
    `Your school hasn't published the booklist for ${cls} yet`,
  browseBooks: "Browse School Books",
  schoolNotActive: (school: string) =>
    `${school} isn't taking orders on Akaiva Edu Power right now.`,
  offline: "Connect to add items",
  viewCart: "View cart",
  cartBar: (items: number, total: string) =>
    `${items} ${items === 1 ? "item" : "items"} · ${total}`,
  cartEmpty: "Your cart is empty",
  cartPanel: "Your cart",
  subtotal: "Subtotal",
  noProducts: "Nothing here for this class yet.",
  loadMore: "Show more",
  retry: "Try again",
  loadFailed: "Couldn't load this. Check your connection and try again.",
  notLinked: "Not linked — link to a school",
} as const;

const CART_MESSAGES: Record<string, string> = {
  PRODUCT_UNAVAILABLE: "This item isn't available any more.",
  PRODUCT_NOT_ORDERABLE: "This item can't be ordered yet.",
  CART_LIMIT_REACHED: "Your cart is full. Check out or remove something first.",
  STUDENT_NOT_LINKED:
    "This child isn't linked to a school any more. Link them again to shop.",
  BOOKLIST_NOT_PUBLISHED: "The booklist isn't published any more.",
  SCHOOL_NOT_ACTIVE: "This school isn't taking orders right now.",
};

/** A refusal's message (FR-027); unknown codes get the generic one, with the reference. */
export function cartMessage(error: AppError): {
  text: string;
  reference: string | null;
} {
  if (error.kind === "offline" || error.kind === "timeout")
    return { text: SHOP_COPY.offline, reference: null };
  return {
    text:
      (error.code && CART_MESSAGES[error.code]) ||
      "Something went wrong. Please try again.",
    reference: error.requestId,
  };
}
